module.exports = __webpack_public_path__ + "static/media/grassland.677a423e.png";